import axios from "axios";
import { IAxiosBlankReturn } from "./interface";
import { processAxiosError } from "./processAxiosError";

/**
 * API call to delete data
 *
 * @param url - The API endpoint URL to send the DELETE request to
 * @returns Promise<IAxiosBlankReturn>
 */
export const deleteData = async (url: string): Promise<IAxiosBlankReturn> => {
  // Get data
  try {
    await axios.delete(url);
    // Return successful result
    return { success: true };
  } catch (error: unknown) {
    return processAxiosError("Delete failed", error);
  }
};
